<div class="media profile-media">
  <img class="b-r-10 w-10" src="{{ authService.getUser().employee?.image?.url || 'assets/images/placeholder-user.jpg' }}" alt="">
  <div class="media-body"><span>{{ authService.getUser().name }}</span>
    <p class="mb-0 font-roboto">{{ authService.getUser().roles[0]?.name }} <i class="middle fa fa-angle-down"></i></p>
  </div>
</div>
<ul class="profile-dropdown onhover-show-div">
  <li><a routerLink="/subscriptions"><app-feather-icons [icon]="'user'"></app-feather-icons><span>{{ 'Account ' | translate }}</span></a></li>
  <!-- <li><a href="email"><app-feather-icons [icon]="'mail'"></app-feather-icons><span>{{ 'Inbox' | translate }}</span></a></li>
  <li><a href="/to-do"><app-feather-icons [icon]="'file-text'"></app-feather-icons><span>{{ 'Taskboard' | translate }}</span></a></li>
  <li><a href="/faq"><app-feather-icons [icon]="'settings'"></app-feather-icons><span>{{ 'Settings' | translate }}</span></a></li> -->
  <li (click)="logoutFunc()"><app-feather-icons [icon]="'log-in'"></app-feather-icons><span>{{ 'Log out' | translate }}</span></li>
</ul>